import { Button, Container, Form, FormField, SelectProps } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect } from 'react';
import { CustomAppLayout } from '../../../layout';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiFileExcel } from '@mdi/js';
import Icon from '@mdi/react';
import * as XLSX from "xlsx";
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import SelectCategory from '../../../../../components/selects/selectCategory';
import SelectFlightTypes from '../../../../../components/selects/selectFlightTypes';
import SelectGroupType from '../../../../../components/selects/selectGroupType';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';


type OptionDefinition = SelectProps.Option;

export const DownloadsFlightsPage = () => {
    const { data, menu, parameters } = useGlobalState();



    const [selectedGroupTypes, setSelectedGroupTypes] = React.useState<OptionDefinition[]>([]);
    const [listGroupTypes, setListGroupTypes] = React.useState<OptionDefinition[]>([]);

    const [selectedFlightTypes, setSelectedFlightTypes] = React.useState<OptionDefinition[]>([]);
    const [listFlightTypes, setListFlightTypes] = React.useState<OptionDefinition[]>([]);

    const [selectedCategories, setSelectedCategories] = React.useState<OptionDefinition[]>([]);
    const [listCategories, setListCategories] = React.useState<OptionDefinition[]>([]);


    const handleRefreshMovements = async () => {
        if (parameters.month && parameters.year) {

            try {
                setLoading(true)

                const idFlightTypes: number[] = selectedFlightTypes
                    .map(opt => opt.value ? Number(opt.value) : undefined) // convert string → number
                    .filter((v): v is number => v !== undefined);
                const idGroupTypes: number[] = selectedGroupTypes
                    .map(opt => opt.value ? Number(opt.value) : undefined) // convert string → number
                    .filter((v): v is number => v !== undefined);
                const idCategories: number[] = selectedCategories
                    .map(opt => opt.value ? Number(opt.value) : undefined) // convert string → number
                    .filter((v): v is number => v !== undefined);

                const bodyObject: any = {
                    orderBy: "departureDate",
                    order: "desc",
                    limit: 1000,
                    columns: "registration, equipmentType, model, make, groupType, groupTypeMaster, groupTypeMasterCode, idFlight, departureDate, arrivalDate,  altitude, idTowingTo,  cost, tacStart, tacEnd, tacDelta, departureArrivalDelta, timeCount, isInvoice, isTowPlane, hourCost, hourCostFree,  costReal, receipt, delta, category,  userPilot, userInstructor, userCost,flightType"
                };
                if (parameters.period !== "") {
                    bodyObject.month = parameters.period.split("-")[1];
                    bodyObject.year = parameters.period.split("-")[0];
                }
                if (idFlightTypes !== undefined && idFlightTypes.length > 0) {
                    bodyObject.idFlightTypes = idFlightTypes;
                }
                if (idGroupTypes !== undefined && idGroupTypes.length > 0) {
                    bodyObject.idGroupTypes = idGroupTypes;
                }
                if (idCategories !== undefined && idCategories.length > 0) {
                    bodyObject.idCategories = idCategories;
                }

                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/flights/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify(bodyObject),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                if (data.code == 0) {
                    if (data.flights.length === 0) {
                        addNotificationStatus(data, setData);
                    } else {
                        const ws = XLSX.utils.json_to_sheet(data.flights);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, "Flights");
                        XLSX.writeFile(wb, `Vuelos.${parameters.period}.xlsx`);
                    }

                } else {
                    addNotificationStatus(data, setData);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }
    useEffect(() => {
        const ids: OptionDefinition[] = data.bookingTypes.map((item: { idBookingType: any; bookingType: any; }) => ({
            value: item.idBookingType,   // map idCheck → value
            label: item.bookingType      // map check → label
        }));
        setListFlightTypes(ids)
        const ids2: OptionDefinition[] = data.groupTypes.map((item: { idGroupType: any; groupType: any; }) => ({
            value: item.idGroupType,   // map idCheck → value
            label: item.groupType      // map check → label
        }));
        setListGroupTypes(ids2)
        const ids3: OptionDefinition[] = data.categories.map((item: { idCategory: any; category: any; }) => ({
            value: item.idCategory,   // map idCheck → value
            label: item.category      // map check → label
        }));
        setListCategories(ids3)
    }, [data]);


    return (
        <CustomAppLayout
            toolsHide
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">

                        <Header actions={<Favorites />}>
                            Descarga de archivo de bitácora de vuelos
                        </Header>
                        <Container>
                            <Form >
                                <SpaceBetween direction='vertical' size="xs">
                                    <SpaceBetween direction='horizontal' size="xs">
                                        <FormField label="Periodo">
                                            <div style={{ width: 130 }}>
                                                <MPModal
                                                    width={120}
                                                    today prevMonth nextMonth
                                                    end={new Date()}
                                                    date={`${parameters.period}`}
                                                    onConfirm={(date) => {
                                                        setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                                    }}
                                                />
                                            </div>
                                        </FormField>

                                        <FormField label="&nbsp;">
                                            <Button onClick={handleRefreshMovements} style={{ root: btnIconForm }} disabled={parameters.year === "" || parameters.month === ""}><Icon path={mdiFileExcel} size={1} /></Button>
                                        </FormField>

                                    </SpaceBetween>

                                    <FormField label="Grupo de aeronave">
                                        <SelectGroupType single={false} width={300}
                                            value={parameters.idGroupTypes}
                                            onSelect={(options) => {
                                                setParameters({
                                                    ...parameters,
                                                    idGroupTypes: options,
                                                });
                                            }}
                                        />
                                    </FormField>
                                    <FormField label="Tipo de vuelo">
                                        <SelectFlightTypes single={false} width={300}
                                            showOnFlightLog={1}
                                            value={parameters.idFlightTypes}
                                            onSelect={(options) => {
                                                setParameters({
                                                    ...parameters,
                                                    idFlightTypes: options,
                                                });
                                            }}
                                        />
                                    </FormField>
                                    <FormField label="Categoría de aeronave">
                                        <SelectCategory single={false} width={300}
                                            value={parameters.idCategories}
                                            onSelect={(options) => {
                                                setParameters({
                                                    ...parameters,
                                                    idCategories: options,
                                                });
                                            }}
                                        />
                                    </FormField>
                                </SpaceBetween>
                            </Form>
                        </Container>
                    </SpaceBetween>
                </>
            }
        />
    );
};
